module.exports = __webpack_public_path__ + "img/qyyxU4.65892153.png";